import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';

import { useDispatch } from 'react-redux';
import { Helmet } from 'react-helmet-async';
import '../css/style.css';
import Category from "../component/category";
import Matches from "../component/matches";
import seoMetaMap from '../utils/seoMetaMap';



const Football = () => {
    const dispatch = useDispatch();

 

    const { category = 'FOOTBALL' } = useParams();

    const categoryKey = category.toLowerCase();
    const meta = seoMetaMap[categoryKey] || seoMetaMap.all;

    const metaURL = `https://pbc88-live.app/${category}/1`;
    const metaImage = 'https://pbc88-live.app/img/PBC88 LIVE.jpg';
    

    useEffect(() => {
    
        
    }, [dispatch]);

    return (
        <>
            <Helmet>
                <title>{meta.title}</title>
                <meta name="description" content={meta.description} />
                <meta property="og:title" content={meta.title} />
                <meta property="og:description" content={meta.description} />
                <meta property="og:url" content={metaURL} />
                <meta property="og:image" content={metaImage} />
            </Helmet>

            <div className="matches">
            <Category selectedCategory="FOOTBALL" />
                <Matches />
            </div>
        </>
    );
};

export default Football;
